export enum BuyerOppMarketplaceTab {
    Timeline = 1,
    DeadlineDocket = 2,
    Documents = 3,
    CommsHub = 4,
    EngagementHistory = 5,
    DealTeam = 6,
    DataRoom = 7,
    SellerProfile = 8,
}

export const BuyerOppMarketplaceTabs = [
    { id: BuyerOppMarketplaceTab.Timeline, content: 'Timeline' },
    { id: BuyerOppMarketplaceTab.DeadlineDocket, content: 'Deadline Docket' },
    {
        id: BuyerOppMarketplaceTab.Documents,
        content: 'Documents',
    },
    {
        id: BuyerOppMarketplaceTab.CommsHub,
        content: 'Comms Hub',
    },
    {
        id: BuyerOppMarketplaceTab.EngagementHistory,
        content: 'Engagement History',
    },
    {
        id: BuyerOppMarketplaceTab.DealTeam,
        content: 'Deal Team',
    },
    {
        id: BuyerOppMarketplaceTab.DataRoom,
        content: 'Data Room',
    },
    {
        id: BuyerOppMarketplaceTab.SellerProfile,
        content: 'Seller Profile',
    },
];
